class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._eventAttached = false;
    setTimeout(() => {
      this.form = this.querySelector('form');
      this.idInput = this.form.elements['id'];
      this.submitButton = this.form.elements['add'];

      this.idInput.removeAttribute('disabled');

      this.notifyOnAdd = this.hasAttribute('notify-on-add');

      this._boundSubmit = this.submit.bind(this);

      this._gifit_time = document.getElementById('gift-time');      

      this._eventAttached = true;
      this.form.addEventListener('submit', this._boundSubmit);
    });
  }

  disconnectedCallback() {
    if (this._eventAttached) {
      this._eventAttached = false;
      this.form.removeEventListener('submit', this._boundSubmit);
    }
  }

  async submit(e) {
    e.preventDefault();

      if(this._gifit_time){
       this._gifit_time.value = Date.now();
      }

    const data = new FormData(e.target);
    const item = Object.fromEntries(data.entries());
    
    try {
      this.removeError();
      await this._setIsAdding();
      await window.theme.cart.store.getState().add(item);
      await this._setIsAdding(false);

      const quickShop = this.closest('quick-shop');
       console.log(item);
      if (quickShop) {
        await quickShop.hide();
      }

      if (this.notifyOnAdd) {
        await window.theme.cart.store.getState().resetVariantsBeingAdded();
        if (!this.closest('.cart-draw')) theme.mfpOpen('cart');
      } else {
        await window.theme.cart.store.getState().resetLatestAddedProduct();
        await window.theme.cart.store
          .getState()
          .resetVariantsBeingAdded(item.id);
      }
    } catch (e) {
      this._renderError(e.message);
      await this._setIsAdding(false, true);
    }

    const gifit_data_product = document.querySelector('[gifit_data_product]') || null;
    if(gifit_data_product){
     if(gifit_data_product.checked){
       const product_gift_man = document.querySelector('[data-product-gift-cart]') || null;
       if(!product_gift_man) return;
       const form_data_cust = product_gift_man.querySelector('form') || null;
       if(!form_data_cust) return;
       document.querySelector('#gift-time_gift').value = this._gifit_time.value;
       console.log("time",this._gifit_time.value)
        const data_custom = new FormData(form_data_cust);
        const item_cust = Object.fromEntries(data_custom.entries());
        await window.theme.cart.store.getState().add(item_cust);
        await window.theme.cart.store.getState().resetVariantsBeingAdded();
               await window.theme.cart.store
          .getState()
          .resetVariantsBeingAdded(item_cust.id);
     } 
    }    
  }

  _setIsAdding(isAdding = true, error = false) {
    return new Promise((resolve) => {
      if (!this.submitButton) {
        resolve('No submit button');
        return;
      }

      if (error) {
        this.submitButton.classList.remove('is-adding');
        resolve('error');
        return;
      }

      if (isAdding) {
        this.submitButton.classList.remove('is-added');
        this.submitButton.classList.add('is-adding');
        resolve('Adding');
      } else {
        this.submitButton.classList.remove('is-adding');
        this.submitButton.classList.add('is-added');

        this.submitButton.addEventListener('animationend', () => {
          this.submitButton.classList.remove('is-added');
          resolve('Added');
        });
      }
      return;
    });
  }

  _renderError(message) {
    this.removeError();

    if (this.submitButton) {
      const error = document.createElement('div');
      error.classList.add('errors', 'qty-error', 'u-small');
      error.innerHTML = message;
      // this.submitButton.before(error);
      this.form.before(error);
    }
  }

  removeError() {
    const error = this.querySelector('.errors');
    if (!error) return;

    error.remove();
  }
}
customElements.define('product-form', ProductForm);
